// Gestão → Metas de prazo (SLA) por tipo de serviço e de 1ª resposta.
// A lista de causas / soluções fica em Listas.
// As metas pintam o Quadro (verde/laranja/vermelho), o Dashboard do dia e o "no prazo" dos relatórios.
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, InputAdornment, Paper, TextField, Typography } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import suporteApi, { mensagemErro } from "../api";
import { useEstilosGestao } from "./Hoje";

const Metas = () => {
  const c = useEstilosGestao();
  const [d, setD] = useState(null);
  const [horas, setHoras] = useState({});
  const [resp, setResp] = useState("");
  const [salvando, setSalvando] = useState(false);

  const aplicar = (data) => {
    setD(data);
    setHoras(Object.fromEntries(data.tipos.map((t) => [t.tipo, t.minutos ? String(t.minutos / 60) : ""])));
    setResp(data.primeira_resposta ? String(data.primeira_resposta) : "");
  };
  useEffect(() => {
    suporteApi.get("/api/gestao/metas").then((r) => aplicar(r.data)).catch((e) => toast.error(mensagemErro(e)));
  }, []);

  const salvar = async () => {
    const metas = Object.fromEntries(Object.entries(horas).map(([t, h]) => [t, h ? Math.round(Number(String(h).replace(",", ".")) * 60) : 0]));
    metas._PRIMEIRA_RESPOSTA = resp ? Math.round(Number(resp)) : 0;
    setSalvando(true);
    try {
      aplicar((await suporteApi.put("/api/gestao/metas", { metas })).data);
      toast.success("Metas salvas");
    } catch (e) {
      toast.error(mensagemErro(e));
    }
    setSalvando(false);
  };

  return (
    <MainContainer>
      <MainHeader><Title>Metas de prazo</Title></MainHeader>
      {!d ? <Typography color="textSecondary">Carregando…</Typography> : (
        <div className={c.raiz} style={{ padding: 0 }}>
          <div className={c.grade}>
            <Paper variant="outlined" className={c.painel}>
              <div className={c.titulo}>Prazo para finalizar, por tipo de serviço</div>
              {d.tipos.map((t) => (
                <div key={t.tipo} className={c.linha}>
                  <span className={c.nome}>{t.tipo}</span>
                  <TextField id={`meta-${t.tipo}`} size="small" variant="outlined" type="number" value={horas[t.tipo] ?? ""}
                    onChange={(e) => setHoras({ ...horas, [t.tipo]: e.target.value })} placeholder="sem meta" style={{ width: 150 }}
                    inputProps={{ min: 0, step: 0.5 }} InputProps={{ endAdornment: <InputAdornment position="end">horas</InputAdornment> }} />
                  <span className={c.nota}>{horas[t.tipo] ? `laranja a partir de ${Math.round(Number(horas[t.tipo]) * 45)} min` : ""}</span>
                </div>
              ))}
              <div className={c.titulo} style={{ marginTop: 16 }}>1ª resposta</div>
              <div className={c.linha}>
                <span className={c.nome}>Da abertura do card à 1ª mensagem do suporte</span>
                <TextField id="meta-resp" size="small" variant="outlined" type="number" value={resp} onChange={(e) => setResp(e.target.value)}
                  style={{ width: 150 }} inputProps={{ min: 0 }} InputProps={{ endAdornment: <InputAdornment position="end">min</InputAdornment> }} />
              </div>
              <div style={{ marginTop: 14, display: "flex", gap: 8 }}>
                <Button variant="contained" color="primary" disabled={salvando} onClick={salvar}>Salvar metas</Button>
              </div>
              <div className={c.nota} style={{ marginTop: 10 }}>
                As metas pintam o Quadro (verde no prazo, laranja a partir de 75% da meta, vermelho estourado), o Dashboard do dia e
                o "no prazo" dos relatórios. Tipo sem meta fica fora do cálculo de prazo. Chamado interno não tem meta.
              </div>
            </Paper>
          </div>
        </div>
      )}
    </MainContainer>
  );
};

export default Metas;
